import { ReorderList, type ReorderItem } from '@/components/shared/reorder-list';
import type { Activity } from '@/data/idp/plans/interfaces';

interface ReorderActivitiesProps {
  activities: Activity[];
  planId: string;
  updateActivities: (activities: Activity[]) => void;
}

export const ReorderActivities = ({
  activities,
  updateActivities,
}: ReorderActivitiesProps) => {
  const handleReorder = (items: ReorderItem[]) => {
    const reordered = items.map(
      (item) => activities.find((a) => a.id === item.id)!
    );
    updateActivities(reordered);
  };

  return <ReorderList items={activities} onReorder={handleReorder} />;
};
